import { Outlet, useLocation, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useModules } from "../../hooks";
// import ErrorPage from "../../components/ErrorPage";

const SHARED_CRYPTO_ACTIONS = [
  "/crypto-deposit",
  "/crypto-buy",
  "/crypto-sell",
  "/crypto-withdraw",
];

const CryptoRoutes = () => {
  const location = useLocation();

  const isBitpaceEnabled = useModules("Bitpace");
  const isFireblocksEnabled = useModules("Fireblocks");
  const isCryptoEnabled = useModules("Crypto");

  const { clientInfo, isLoading: clientLoading } = useSelector((state) => state.client);

  // 1. Wait until clientInfo is finished loading
  if (clientLoading || !clientInfo) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <span className="loading loading-spinner" />
      </div>
    );
  }

  // 2. Global check: Crypto module must be active
  if (!isCryptoEnabled) {
    // return <ErrorPage />;
    return <Navigate to="/" replace />;
  }

  // 3. Fireblocks is disabled, but Bitpace is enabled:
  // Redirect /v2/crypto routes back to legacy /crypto
  const isV2CryptoPath = location.pathname.startsWith("/v2/crypto");
  if (!isFireblocksEnabled && isBitpaceEnabled && isV2CryptoPath) {
    return <Navigate to="/crypto" replace />;
  }

  // 4. Bitpace is disabled checks
  if (!isBitpaceEnabled) {
    const isAdvancePath = location.pathname.startsWith("/crypto-advance");
    const isManualPath = location.pathname === "/crypto";
    const isSharedActionPath = SHARED_CRYPTO_ACTIONS.includes(location.pathname);

    // If accessing shared actions or manual path while Fireblocks is enabled -> redirect to /v2/crypto
    if ((isSharedActionPath || isManualPath) && isFireblocksEnabled) {
      return <Navigate to="/v2/crypto" replace />;
    }

    // Fallback redirect to home if modules don't allow access
    if (isAdvancePath || isManualPath || isSharedActionPath) {
      return <Navigate to="/" replace />;
    }
  }

  return <Outlet />;
};

export default CryptoRoutes;